$(() => {
  let currentMainFeatureCategory;
  currentMainFeatureCategory = $(
    "input[name='saas_content[main_saas_category]']:checked"
  ).val();
  $('.show-main-saas-feature').on('change', function () {
    const cat = $(
      "input[name='saas_content[main_saas_category]']:checked"
    ).val();
    const target = `#main_feature_container_${cat}`;
    const disabledSubCatCb = `#saas_content_sub_saas_category_ids_${cat}`;
    if (currentMainFeatureCategory != undefined) {
      const prev = `#main_feature_container_${currentMainFeatureCategory}`;
      const enabledSubCatCb = `#saas_content_sub_saas_category_ids_${currentMainFeatureCategory}`;
      $(prev).hide();
      $(enabledSubCatCb).prop('disabled', false);
    }
    currentMainFeatureCategory = cat;
    $(target).show();
    if ($(disabledSubCatCb).prop('checked')) {
      $(disabledSubCatCb)
        .attr('checked', false)
        .prop('checked', false)
        .change();
    }
    $(disabledSubCatCb).prop('disabled', true);
  });

  $('.toggle-sub-saas-feature').on('change', function () {
    const cat = $(this).val();
    const target = `#sub_feature_container_${cat}`;
    $(target).toggle();
  });

  $('.toggle-fee-amount-fields').on('change', function () {
    const index = $(this).data('feeindex');
    const val = $(
      `input[name='saas_content[saas_fee_plans_attributes][${index}][fee_type]']:checked`
    ).val();
    const target = `#amount_fields_${index}`;

    if (val == 'amount') {
      $(target).show();
    } else {
      $(target).hide();
    }
  });

  $('.toggle-fee-plan').on('change', function () {
    const index = $(this).data('feeindex');
    const val = $(this).prop('checked');
    const target = `#fee_plan_${index}`;

    if (val) {
      $(target).show();
    } else {
      $(target).hide();
    }
  });

  $('.operator-copy-button').on('click', function() {
    const operatorNameInput = $('#saas_content_operator_name');
    const operatorNameData = operatorNameInput.data('hnavi-data'); 
    const operatorHqAddressInput = $('#saas_content_operator_hq_address');
    const operatorHqAddressData = operatorHqAddressInput.data('hnavi-data'); 
    const operatorEstablishedAt1iInput = $('#saas_content_operator_established_at_1i');
    const operatorEstablishedAtData = operatorEstablishedAt1iInput.data('hnavi-data'); 
    const operatorEstablishedAt2iInput = $('#saas_content_operator_established_at_2i');
    const operatorEmployeeCountInput = $('#saas_content_operator_employee_count');
    const operatorEmployeeCountData = operatorEmployeeCountInput.data('hnavi-data') ;
    const operatorCapitalInput = $('#saas_content_operator_capital');
    const operatorCapitalData = operatorCapitalInput.data('hnavi-data') ;
    const operatorRepresentativeInput = $('#saas_content_operator_representative');
    const operatorRepresentativeData = operatorRepresentativeInput.data('hnavi-data'); 
    const operatorUrlInput = $('#saas_content_operator_url');
    const operatorUrlData = operatorUrlInput.data('hnavi-data');
    const establishedAt = new Date(operatorEstablishedAtData);

    operatorNameInput.val(operatorNameData);
    operatorEstablishedAt1iInput.val(establishedAt.getFullYear());
    operatorEstablishedAt2iInput.val(establishedAt.getMonth() + 1);
    operatorHqAddressInput.val(operatorHqAddressData);
    operatorEmployeeCountInput.val(operatorEmployeeCountData);
    operatorCapitalInput.val(operatorCapitalData);
    operatorRepresentativeInput.val(operatorRepresentativeData);
    operatorUrlInput.val(operatorUrlData);
  });
});
